import React from "react";

export const getYoutubeIframe = (code: string, width: number | string, height: number | string) => {
    const src = `https://www.youtube.com/embed/${code}`;

    return (
        <iframe
            width={width}
            height={height}
            src={src}
            frameBorder="0"
            // gesture="media"
            // allow="encrypted-media"
            allowFullScreen
        />
    );
};
